module.exports = __webpack_public_path__ + "static/media/contact-page-image.72e284e9.webp";